import { render } from "./mapBlock.vue?vue&type=template&id=05034102"
import script from "./mapBlock.vue?vue&type=script&lang=js"
export * from "./mapBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__